import { render, staticRenderFns } from "./TopFundsOpportunitiesTable.vue?vue&type=template&id=6b28babc&scoped=true"
import script from "./TopFundsOpportunitiesTable.vue?vue&type=script&lang=js"
export * from "./TopFundsOpportunitiesTable.vue?vue&type=script&lang=js"
import style0 from "./TopFundsOpportunitiesTable.vue?vue&type=style&index=0&id=6b28babc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b28babc",
  null
  
)

export default component.exports